import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/core/lib/utils';
import { Input } from '@/shared/components/ui/input';
import { isAllowedEmbedUrl } from '../utils/embed-validator';

interface VideoEmbedInputProps {
  onInsert: (url: string) => void;
  onCancel: () => void;
  className?: string;
}

export function VideoEmbedInput({ onInsert, onCancel, className }: VideoEmbedInputProps) {
  const { t } = useTranslation('richText');
  const [url, setUrl] = useState('');
  const [touched, setTouched] = useState(false);

  const isValid = isAllowedEmbedUrl(url);
  const showError = touched && url.length > 0 && !isValid;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!isValid) return;
    onInsert(url);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={cn(
        'flex flex-col gap-2 rounded-lg border border-border bg-popover p-3 shadow-md',
        className,
      )}
    >
      <Input
        type="url"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        onBlur={() => setTouched(true)}
        placeholder={t('video.urlPlaceholder')}
        autoFocus
        className="h-8 text-sm"
      />
      {showError && <span className="text-xs text-destructive">{t('video.invalid')}</span>}
      <div className="flex gap-2">
        <button
          type="submit"
          disabled={!isValid}
          className="flex-1 rounded bg-primary px-3 py-1.5 text-xs font-medium text-primary-foreground disabled:opacity-50"
        >
          {t('video.insert')}
        </button>
        <button
          type="button"
          onClick={onCancel}
          className="rounded border border-border px-3 py-1.5 text-xs text-muted-foreground hover:bg-accent"
        >
          ✕
        </button>
      </div>
    </form>
  );
}
